<div
  class="bottom-popup"
  [class.is-visible]="showPopup"
  [ngClass]="'popup-' + type"
>
  <div class="icon" aria-hidden="true">
    <svg [class.is-active]="type === 'info'" viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="10"></circle>
      <path d="M12 16v-4"></path>
      <path d="M12 8h.01"></path>
    </svg>
    <svg [class.is-active]="type === 'warning'" viewBox="0 0 24 24">
      <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"></path>
      <path d="M12 9v4"></path>
      <path d="M12 17h.01"></path>
    </svg>
    <svg [class.is-active]="type === 'error'" viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="10"></circle>
      <path d="m15 9-6 6"></path>
      <path d="m9 9 6 6"></path>
    </svg>
    <svg [class.is-active]="type === 'success'" viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="10"></circle>
      <path d="m9 12 2 2 4-4"></path>
    </svg>
  </div>
  <div class="content">
    <h2>{{ title }}</h2>
    <p>{{ message }}</p>
  </div>
  <button class="dismiss-btn" type="button" (click)="dismiss()" aria-label="Dismiss">
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M18 6 6 18"></path>
      <path d="m6 6 12 12"></path>
    </svg>
  </button>
</div>
